import React from "react";
import Papa from "papaparse";
import {
  Button,
  Form,
  Label,
  Modal,
  Checkbox,
  Grid,
  Progress,
} from "semantic-ui-react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { socket } from "../../../lib/socketio";
import { setPPID } from "../../../actions/headerActions";
import { setCurrentPLC } from "../../../actions/headerActions";
import { createUserLog } from "../../../lib/api";
import {
  isAuthorized,
  RETUNE_LOAD,
  RETUNE_SAVE,
} from "../../../lib/authorization";

const Retune_MAIN = ({ ppid }) => {
  const [open, setOpen] = React.useState(false);
  const [buttonClickType, setButtonClickType] = React.useState({
    buttonClick: "",
  });
  const [tagData, setTagData] = React.useState();
  const [loadFilePath, setLoadFilePath] = React.useState("");
  const [saveFilePath, setSaveFilePath] = React.useState("");
  const [loadObjectToSend, setLoadObjectToSend] = React.useState([]);
  const [loadComplete, setLoadComplete] = React.useState(0);
  const [loadObject, setLoadObject] = React.useState();
  const [isCsvDone, setIsCsvDone] = React.useState(false);

  // update 240315 by sumin, display each load/save status
  const [isSaveReady, setIsSaveReady] = React.useState(0);
  const [isLoadReady, setIsLoadReady] = React.useState(0);

  // update Compare File
  const [secondModalOpen, setSecondModalOpen] = React.useState(false);
  const [compareFilePath, setCompareFilePath] = React.useState("");
  const [compareData, setCompareData] = React.useState("");
  const [defaultFilePath, setDefaultFilePath] = React.useState("");
  const [defaultData, setDefaultData] = React.useState("");
  const [resultData, setResultData] = React.useState({});
  const [checked, setChecked] = React.useState(false);
  const [diffData, setDiffData] = React.useState([]);
  const [deleteClick, setDeleteClick] = React.useState(false);
  // const [diffData, setDiffData] = React.useState([]);
  const fileReader = new FileReader();
  const defaultFileReader = new FileReader();

  // update 240516 by sumin, Load file err msg
  const [loadFileErr, setLoadFileErr] = React.useState(false);
  var loadFilePPC = "";

  // @ TEST : retune progress bar
  const [progress, setProgress] = React.useState(0);

  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.nav.user);
  const electronApp = useSelector((state) => state.nav.electronApp);

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  // @ TEST : retune progress bar
  React.useEffect(() => {
    if (Object.values(loadFilePath).length > 0) {
      socket.on("retune count", (value) => {
        setProgress(
          parseInt(
            (value.result.count /
              (Object.values(loadObjectToSend).length / 30 - 1)) *
              100,
          ),
        );
      });
    }
  });

  React.useEffect(() => {
    if (buttonClickType.buttonClick !== "") {
      if (buttonClickType.buttonClick === "Retune Save Main") {
        socket.emit("button click", { buttonClickType: "Retune Save Main" });
        socket.on("receive retune values", (value) => {
          setTagData(value.result);
        });

        setIsSaveReady(1);
        if (!electronApp) {
          let log = {
            user_id: user.id,
            powerplant_id: ppid,
            display_id: null,
            datetime: new Date().toISOString(),
            data: JSON.stringify({ type: "Retune Save" }),
          };
          createUserLog({ log }).catch(console.error);
        }
      }

      if (buttonClickType.buttonClick === "Retune Load") {
        setIsLoadReady(2);
        Papa.parse(loadObject, {
          header: false,
          download: true,
          skipEmptyLines: true,
          // Here this is also available. So we can call our custom class method
          complete: updateData,
        });
      }
    }

    return () => {
      socket.removeAllListeners();
    };
  }, [buttonClickType]);

  React.useEffect(() => {
    if (saveFilePath === "") {
      let fileName = "RetuneLog_MAIN_";
      const d = new Date();
      // const id = ppid.toString() + "_";
      const id =
        typeof ppid !== "undefined" && typeof ppid !== "null"
          ? ppid.toString() + "_"
          : "9999_";
      // const id = "ppid_"
      fileName += id;
      const datestring =
        d.getDate() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getFullYear() +
        " " +
        d.getHours() +
        "-" +
        d.getMinutes();
      fileName += datestring.replace(/ /g, "_");
      setSaveFilePath(fileName);
    }
  }, [saveFilePath]);

  React.useEffect(() => {
    if (
      typeof tagData !== "undefined" &&
      tagData !== null &&
      isCsvDone === false
    ) {
      const tags_names = Object.keys(tagData);
      const tag_values = Object.values(tagData);
      let csv = "";

      tags_names.forEach((tag_name_el, idx) => {
        let row = "";
        row += '"' + tag_name_el + '",';
        row += '"' + tag_values[idx] + '",';
        csv += row + "\r\n";
      });

      let uri = "data:text/csv;charset=utf-8," + escape(csv);
      let link = document.createElement("a");
      link.href = uri;
      link.style = "visibility:hidden";
      link.download = saveFilePath + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsCsvDone(true);
      setIsSaveReady(2);
    }
  }, [tagData]); // CSV 파일로 저장

  React.useEffect(() => {
    if (loadComplete === 1) {
      socket.emit("button click", {
        buttonClickType: "Retune Load",
        tags: loadObjectToSend,
      });
      socket.on("retune ready", (value) => {
        // setIsReady(value.result.ready);
        // console.log(value.result.ready);
        setIsLoadReady(value.result.ready);
        setLoadComplete(0);
        // setLoadFilePath('');
        // setIsLoadReady(3);
        if (!electronApp) {
          let log = {
            user_id: user.id,
            powerplant_id: ppid,
            display_id: null,
            datetime: new Date().toISOString(),
            data: JSON.stringify({ type: "Retune Load" }),
          };
          createUserLog({ log }).catch(console.error);
        }
      });
    }
    return () => {
      socket.removeAllListeners();
    };
  }, [loadComplete]);

  // update 240411 by sumin, bugfix - reset loadObjectToSend
  // @ TEST -> 위치 변경해야함, 이상하게 작동함...
  // React.useEffect(() => {
  //     console.log(loadObjectToSend);
  //     if(isLoadReady === 3){
  //         setLoadObjectToSend([]);
  //     }
  // }, [isLoadReady]);

  const updateData = (result) => {
    result.data.forEach((rowEl) => {
      if (rowEl[0].startsWith("MAIN_")) {
        var temp = { tag_name: rowEl[0], tag_value: rowEl[1] };
        loadObjectToSend.push(temp);
      }
    });
    setLoadComplete(1);
  };

  const handleOpen = () => {
    setOpen(true);
    setIsSaveReady(0);
    setIsLoadReady(0);
    setLoadFilePath("");
    setCompareFilePath("");

    // @ TEST : retune progress
    if (progress > 0 && progress < 100) {
      setIsLoadReady(2);
    }

    if (!deleteClick) {
      setDefaultFilePath(localStorage.getItem("defaultFilePath"));
      setDefaultData(JSON.parse(localStorage.getItem("defaultData")));
    }
  };

  const handleClose = () => setOpen(false);

  const handleLoadClick = () => {
    if (typeof loadObject !== "undefined" && loadFilePath !== "") {
      // @ TEST : loadObject 초기화
      setLoadObjectToSend([]);

      setButtonClickType({
        ...buttonClickType,
        ["buttonClick"]: "Retune Load",
      });
    }
  };

  const handleSaveClick = () => {
    setIsSaveReady(2);
    setIsCsvDone(false);
    setButtonClickType({
      ...buttonClickType,
      ["buttonClick"]: "Retune Save Main",
    });
  };

  const handleSaveFilePathChange = (e, { value }) => {
    setSaveFilePath(value);
  };

  const handleLoadPathChange = (e, { value }) => {
    // @ TEST : retune pregress bar
    if (value.length === 0) {
      setProgress(0);
    } else if (isLoadReady !== 2) {
      setProgress(0);
    }

    setLoadFilePath(value);
    setLoadObject(e.target.files[0]);
    setIsLoadReady(1);

    // update 240516 by sumin, check Load File name
    if (
      e.target.files[0] !== "" &&
      e.target.files[0] !== "undefined" &&
      Object.keys(e.target.files).length > 0
    ) {
      let splitTemp = e.target.files[0].name.split("_")[1];
      loadFilePPC =
        splitTemp.includes("PSM") || splitTemp.includes("MAIN")
          ? splitTemp
          : "";

      if (loadFilePPC.length !== 0 && loadFilePPC !== "") {
        if (loadFilePPC === currentPLC) {
          setLoadFileErr(false);
        } else {
          setLoadFileErr(true);
          setIsLoadReady(0);
        }
      } else {
        setLoadFileErr(true);
        setIsLoadReady(0);
      }
    }

    if (Object.keys(e.target.files).length === 0) {
      setLoadFileErr(false);
      setIsLoadReady(0);
    }
  };

  // @ TEST : retune progress bar
  const handleCompareFilePathChange = (e, { value }) => {
    setCompareFilePath(value);

    if (e.target.files[0]) {
      fileReader.onload = (event) => {
        const text = event.target.result;
        setCompareData(csvToObj(text));
      };
      fileReader.readAsText(e.target.files[0]);
    }
  };

  const handleDefaultFilePathChange = (e, { value }) => {
    // update, save file to local storage ?
    if (defaultFilePath) {
      setDefaultFilePath(localStorage.getItem("defaultFilePath"));
    } else {
      setDefaultFilePath(value);
    }

    if (e.target.files[0] && !defaultData) {
      defaultFileReader.onload = (event) => {
        const text1 = event.target.result;
        setDefaultData(csvToObj(text1));
      };
      defaultFileReader.readAsText(e.target.files[0]);
    }
  };

  const handleCompareClick = (e) => {
    // 1. defaultObject와 compareObject 비교실행함
    // 2. 두번째 Modal 화면을 open함
    // if(localStorage.getItem('defaultFilePath') ===''){ // 최초 실행시 localStorage에 입력
    //     localStorage.setItem('defaultFilePath', defaultFilePath);
    //     localStorage.setItem('defaultData', JSON.stringify(defaultData));
    // }else{ // 두번째 실행시 localStorage에서 가져옴
    //     let temp = localStorage.getItem('defaultData');
    //     setDefaultData(JSON.parse(temp));
    // }
    localStorage.setItem("defaultFilePath", defaultFilePath);
    const savedData = localStorage.getItem("defaultData");

    if (savedData === null) {
      localStorage.setItem("defaultData", JSON.stringify(defaultData));
    } else {
      setDefaultData(JSON.parse(savedData));
    }

    // update SOFC, bugfix : check defaultFilePath & compareFilePath's type 240320
    if (
      defaultFilePath !== "undefined" &&
      defaultFilePath !== null &&
      compareFilePath !== "undefined" &&
      compareFilePath !== null
    ) {
      if (defaultFilePath.length === 0 || compareFilePath.length === 0) {
        setSecondModalOpen(false);
      } else {
        getCompareResult(compareData, defaultData);
        setSecondModalOpen(true);
      }
    }
  };

  const csvToObj = (file) => {
    const resArray = [];

    //특수문자 제거
    if (file.includes("KEP") || file.includes('"') || file.includes("\r")) {
      file = file.replace(/KEP\\|\"|\r/g, "");
    }

    const csvRows = file.slice(file.indexOf("\n") + 1).split("\n"); // ['KEP\\AL_110ClogBL_Comp,1,Non Standard\r']

    for (let i = 0; i < csvRows.length; i++) {
      let convertArray = [];
      let convertObj = {};

      convertArray = csvRows[i].split(","); // ['AL_110ClogBL_Comp', '1', 'Non Standard\r']
      convertObj[convertArray[0]] = convertArray[1];

      resArray.push(convertObj);
    }
    return resArray;
  };

  const getCompareResult = (obj1, defaultObj) => {
    var diffResult = [];
    // var diff = [];
    if (defaultObj && defaultObj.length > 0) {
      for (let i = 0; i < defaultObj.length; i++) {
        diffResult[i] = {
          name: Object.keys(defaultObj[i]).toString(),
          value: Number(Object.values(defaultObj[i])),
          diffValue: "",
        };
        for (let j = 0; j < obj1.length; j++) {
          if (
            Object.keys(defaultObj[i]).toString().toUpperCase() ===
              Object.keys(obj1[j]).toString().toUpperCase() &&
            Number(Object.values(defaultObj[i])) !==
              Number(Object.values(obj1[j]))
          ) {
            // diff.push({[Object.keys(obj1[j]).toString()] : Number(Object.values(obj1[j]))});
            diffResult[i].diffValue = Number(Object.values(obj1[j]));
          }
          continue;
        }
      }
    }

    setResultData(diffResult);
    setDiffData(diffResult.filter((c) => c.diffValue !== ""));

    return diffResult;
  };

  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
  };

  const handleDeleteDefaultFileClick = (e) => {
    e.preventDefault();
    localStorage.clear();
    setDefaultFilePath("");
    setDefaultData("");
  };

  const gridCompareTitle = () => {
    return (
      <Grid.Row>
        <Grid.Column width={6}>
          <p style={{ fontSize: "13px", fontWeight: "bold" }}>Tag Name</p>
        </Grid.Column>
        <Grid.Column width={3}>
          <p style={{ fontSize: "13px", fontWeight: "bold" }}>Default Value</p>
        </Grid.Column>
        <Grid.Column width={3}>
          <p style={{ fontSize: "13px", fontWeight: "bold" }}>Compare Value</p>
        </Grid.Column>
      </Grid.Row>
    );
  };

  return (
    <div>
      <h1 style={{ textAlign: "center" }}>Retune (MAIN)</h1>
      <Modal
        trigger={<Button color="blue">RETUNE_MAIN</Button>}
        style={{ width: "600px" }}
        open={open}
        closeOnDimmerClick={false}
        onClose={handleClose}
        onOpen={handleOpen}
      >
        <Modal.Header>RETUNE (MAIN)</Modal.Header>

        <Modal.Content>
          <Form>
            <Form.Group widths="equal">
              <Form.Field>
                {/* <Label horizontal basic
                                       size='small'
                                       style={styles.label}
                                       content={(isReady === 0) ? 'Not Ready' : (isReady === 1) ? 'Ready' : 'Loading... Please Wait'}
                                       color={(isReady === 0) ? 'red' : (isReady === 1) ? 'green' : 'blue'}
                                /> */}
                <Label
                  horizontal
                  basic
                  size="small"
                  style={styles.label}
                  content={
                    isSaveReady === 0
                      ? "Save : Ready"
                      : isSaveReady === 1
                        ? "Save : Saving..."
                        : "Save : Complete"
                  }
                  color={
                    isSaveReady === 0
                      ? "green"
                      : isSaveReady === 1
                        ? "green"
                        : "blue"
                  }
                />
                <Label
                  horizontal
                  basic
                  size="small"
                  style={styles.label}
                  content={
                    isLoadReady === 0
                      ? "Load : Not Ready"
                      : isLoadReady === 1
                        ? "Load : Ready"
                        : isLoadReady === 2
                          ? "Load : Loading... Please Wait"
                          : "Load : Complete"
                  }
                  color={
                    isLoadReady === 0
                      ? "red"
                      : isLoadReady === 1 || isLoadReady === 2
                        ? "green"
                        : "blue"
                  }
                />
              </Form.Field>
            </Form.Group>
            <Progress percent={progress} progress />
            <Form.Group widths="equal">
              <Form.Input
                label="Read From File (Load Only)"
                id="read_from_file"
                name="read_from_file"
                type="file"
                accept=".csv"
                size="small"
                value={loadFilePath}
                onChange={handleLoadPathChange}
                error={loadFileErr && { content: `INVALID FILE` }} // update 240516, dipslay file name error
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                label="Write To File (Save Only)"
                id="write_to_file"
                name="write_to_file"
                size="small"
                value={saveFilePath}
                onChange={handleSaveFilePathChange}
              />
            </Form.Group>

            <Form.Group grouped width="equals">
              <label style={{ color: "black" }}>
                Compare File (Compare Only)
              </label>
              <br />

              {defaultFilePath ? (
                <div>
                  <Label
                    content="Default Retune File :"
                    style={{
                      marginRight: "10px",
                      marginBottom: "0px",
                      marginTop: "10px",
                    }}
                    basic
                  >
                    Default retune file :
                    <span style={{ fontWeight: "normal" }}>
                      &nbsp;{" "}
                      {defaultFilePath.includes("C:\\fakepath\\")
                        ? defaultFilePath.replace("C:\\fakepath\\", "")
                        : defaultFilePath}
                    </span>
                  </Label>
                  <Button
                    size="mini"
                    content="Delete File"
                    onClick={handleDeleteDefaultFileClick}
                  />
                </div>
              ) : (
                <div>
                  <Label
                    content="Default Retune File"
                    style={{
                      marginRight: "10px",
                      marginBottom: "0px",
                      marginTop: "10px",
                    }}
                  />
                  <Form.Input
                    id="default_file"
                    name="default_file"
                    type="file"
                    accept=".csv"
                    size="small"
                    value={defaultFilePath}
                    onChange={handleDefaultFilePathChange}
                    readOnly
                    style={{ marginTop: "0px" }}
                  />
                </div>
              )}

              <Label
                content="File to Compare"
                style={{
                  marginRight: "10px",
                  marginBottom: "0px",
                  marginTop: "10px",
                }}
              />
              <Form.Input
                id="compare_file"
                name="compare_file"
                type="file"
                accept=".csv"
                size="small"
                value={compareFilePath}
                onChange={handleCompareFilePathChange}
              />
            </Form.Group>

            {/* <Form.Group widths='equal'>
                            <Form.Input
                                id='compare_file'
                                name='compare_file'
                                type='file'
                                accept='.csv'
                                size='small'
                                value={compareFilePath}
                                onChange={handleCompareFilePathChange}
                            />
                        </Form.Group> */}
          </Form>
        </Modal.Content>
        <Modal.Actions style={{ marginLeft: "10px" }}>
          <Button
            color={"red"}
            size="small"
            id="1"
            content="Exit"
            onClick={handleClose}
          />
          {(electronApp || isAuthorized(user.hmi_role, RETUNE_LOAD)) && (
            <Button
              color={"blue"}
              size="small"
              id="2"
              content="Load Parameters"
              onClick={handleLoadClick}
              disabled={loadFileErr}
            />
          )}
          {(electronApp || isAuthorized(user.hmi_role, RETUNE_SAVE)) && (
            <Button
              color={"blue"}
              size="small"
              id="3"
              content="Save Parameters"
              onClick={handleSaveClick}
            />
          )}
          <Button
            color={"grey"}
            size="small"
            id="4"
            content="Compare"
            onClick={handleCompareClick}
            icon="right chevron"
            labelPosition="right"
          />
        </Modal.Actions>

        <Modal
          onClose={() => setSecondModalOpen(false)}
          onOpen={() => setSecondModalOpen(true)}
          open={secondModalOpen}
          size="small"
        >
          <Modal.Header>Compare</Modal.Header>
          <Form>
            <Checkbox
              label="See All"
              style={{ float: "right", marginRight: "20px", marginTop: "10px" }}
              id="checkbox"
              name="checkbox"
              checked={checked}
              onChange={handleCheckboxChange}
            />
          </Form>
          <p
            style={{
              color: "black",
              float: "left",
              marginLeft: "20px",
              marginTop: "10px",
            }}
          >
            Total :{" "}
            {checked === false && resultData.length > 0
              ? diffData.length > 0 && diffData.length
              : Object.keys(resultData).length}{" "}
          </p>

          <Modal.Content style={{ color: "black" }} scrolling>
            {!checked && diffData.length > 0 ? (
              <Grid>
                {gridCompareTitle()}
                <Grid.Row>
                  {diffData.map((c, i) => {
                    return (
                      <>
                        <Grid.Column
                          width={6}
                          style={{ wordWrap: "breakWord" }}
                        >
                          <span>
                            {JSON.stringify(diffData[i].name).replace(
                              /({|}|"|\[|\])|/g,
                              "",
                            )}
                          </span>
                        </Grid.Column>
                        <Grid.Column width={3} style={{ textAlign: "center" }}>
                          <span>
                            {JSON.stringify(diffData[i].value).replace(
                              /({|}|"|\[|\])|/g,
                              "",
                            )}
                          </span>
                        </Grid.Column>
                        <Grid.Column width={3} style={{ textAlign: "center" }}>
                          <span>
                            {JSON.stringify(diffData[i].diffValue).replace(
                              /({|}|"|\[|\])|/g,
                              "",
                            )}
                          </span>
                        </Grid.Column>
                      </>
                    );
                  })}
                </Grid.Row>
              </Grid>
            ) : (
              <Grid>
                {gridCompareTitle()}
                <Grid.Row>
                  {resultData.length > 0 &&
                    resultData.map((c, i) => {
                      return (
                        <>
                          <Grid.Column
                            width={6}
                            style={{ wordWrap: "breakWord" }}
                          >
                            <span>
                              {JSON.stringify(resultData[i].name).replace(
                                /({|}|"|\[|\])|/g,
                                "",
                              )}
                            </span>
                          </Grid.Column>
                          <Grid.Column
                            width={3}
                            style={{ textAlign: "center" }}
                          >
                            <span>
                              {JSON.stringify(resultData[i].value).replace(
                                /({|}|"|\[|\])|/g,
                                "",
                              )}
                            </span>
                          </Grid.Column>
                          <Grid.Column
                            width={3}
                            style={{ textAlign: "center" }}
                          >
                            <span>
                              {JSON.stringify(resultData[i].diffValue).replace(
                                /({|}|"|\[|\])|/g,
                                "",
                              )}
                            </span>
                          </Grid.Column>
                        </>
                      );
                    })}
                </Grid.Row>
              </Grid>
            )}
          </Modal.Content>
          <Modal.Actions style={{ marginLeft: "10px" }}>
            <Button
              color={"red"}
              size="small"
              id="1"
              content="Exit"
              onClick={() => setSecondModalOpen(false)}
            />
          </Modal.Actions>
        </Modal>
      </Modal>
    </div>
  );
};

const styles = {
  label: {
    float: "right",
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
  header: {
    marginBottom: "15px",
  },
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPPID: (ppid) => dispatch(setPPID(ppid)),
  };
};

const mapStateToProps = (state) => {
  return {
    ppid: state.header.ppid,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Retune_MAIN);
